<template>
  <div
    :class="config.border"
    class="rounded-lg border-2 bg-white p-4 flex flex-col gap-3 flex-1 min-w-[180px]"
    :data-testid="`summary-card-${config.key}`"
  >
    <div class="flex items-center gap-1 text-sm font-medium" :class="config.textColor">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24">
        <path :d="config.icon" fill="currentColor" />
      </svg>
      <span class="text-lg text-textPrimary font-bold">{{ config.label }}</span>
    </div>
    <span class="text-left text-3xl font-bold text-textPrimary" data-testid="summary-card-count">
      {{ count }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { mdiLock, mdiLockOpenVariant } from '@mdi/js'
import { ExceptionStatusEnum } from '@/Network/Types/Requests/DoctorStationExceptionRequests'

interface StatusConfig {
  border: string
  textColor: string
  icon: string
  label: string
  key: string
}

const props = defineProps<{
  status: ExceptionStatusEnum
  count: number
}>()

const STATUS_MAP: Record<string, StatusConfig> = {
  [ExceptionStatusEnum.AWAITING_APPROVAL]: {
    border: 'border-alert',
    textColor: 'text-alert',
    icon: mdiLock,
    label: 'Em andamento',
    key: 'in-progress'
  },
  [ExceptionStatusEnum.APPROVED]: {
    border: 'border-negative',
    textColor: 'text-negative',
    icon: mdiLockOpenVariant,
    label: 'Aprovado',
    key: 'approved'
  },
  [ExceptionStatusEnum.REJECTED]: {
    border: 'border-primary',
    textColor: 'text-primary',
    icon: mdiLock,
    label: 'Reprovado',
    key: 'rejected'
  }
}

const DEFAULT_CONFIG: StatusConfig = {
  border: 'border-gray-300',
  textColor: 'text-gray-500',
  icon: mdiLock,
  label: 'Desconhecido',
  key: 'unknown'
}

const config = computed(() => STATUS_MAP[props.status] ?? DEFAULT_CONFIG)
</script>
